'use client';

import { FormProvider, FormProviderProps } from '../../Form/FormContext';
import {
  applicationFormSchema,
  applicationFormSteps,
} from './ApplicationForm.utils';

export const ApplicationFormProvider = (
  props: Omit<
    FormProviderProps<typeof applicationFormSchema>,
    'schema' | 'steps'
  >,
) => (
  <FormProvider
    schema={applicationFormSchema}
    steps={applicationFormSteps}
    {...props}
  />
);
